/**
 * HeatmapService
 * 
 * Tracks key usage frequency and simultaneous press intensity.
 */
export class HeatmapService extends EventTarget {
  constructor() {
    super();
    this.STORAGE_KEY = 'cytific_heatmap_data';
    this.pressCounts = new Map(); // code -> count
    this.simultaneousIntensity = new Map(); // code -> cumulative intensity
    this.loadData();
  }

  loadData() {
    try {
      const saved = sessionStorage.getItem(this.STORAGE_KEY);
      if (saved) {
        const data = JSON.parse(saved);
        if (data && data.counts) this.pressCounts = new Map(Object.entries(data.counts));
        if (data && data.intensity) this.simultaneousIntensity = new Map(Object.entries(data.intensity));
      }
    } catch (e) { console.warn('Failed to load heatmap data:', e); }
  }

  saveData() {
    try {
      const data = {
        counts: Object.fromEntries(this.pressCounts),
        intensity: Object.fromEntries(this.simultaneousIntensity)
      };
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* ignore */ }
  }

  recordPress(code, activeCount) {
    const current = this.pressCounts.get(code) || 0;
    this.pressCounts.set(code, current + 1);

    if (activeCount > 1) {
      this.simultaneousIntensity.set(code, (this.simultaneousIntensity.get(code) || 0) + (activeCount * 0.1));
    }

    this.dispatchEvent(new CustomEvent('heatmapupdate', {
      detail: {
        code,
        count: current + 1,
        intensity: this.simultaneousIntensity.get(code) || 0
      }
    }));
    this.saveData();
  }

  getKeyStats(code) {
    return {
      count: this.pressCounts.get(code) || 0,
      intensity: this.simultaneousIntensity.get(code) || 0
    };
  }

  clear() {
    this.pressCounts.clear();
    this.simultaneousIntensity.clear();
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}

export const heatmapService = new HeatmapService();
